export default __webpack_public_path__ + "static/media/cabina.7ffd8746.jpg";